import React, { useState } from "react";
import axios from "axios";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [recaptchaToken, setRecaptchaToken] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Obtenir le token reCAPTCHA avant d'envoyer le formulaire
      const token = await window.grecaptcha.execute(
        "6LcJOKcqAAAAAGgqM4Mt21eDnomfhpQz0a8EV_jj",
        { action: "submit" }
      );
      setRecaptchaToken(token);

      if (!token) {
        alert("Veuillez compléter le reCAPTCHA.");
        return;
      }

      const response = await axios.post("https://../send-email.php", {
        ...formData,
        recaptchaToken: token,
      });
      console.log(response.data);
      alert("Message envoyé avec succès!");
    } catch (error) {
      console.error(error);
      alert("Une erreur s'est produite. Veuillez réessayer.");
    }
  };

  return (
    <section className="contact-section" id="contact">
      <div className="contact-content">
        <h3 className="">Contactez-nous</h3>
        <h2>VOUS ÊTES UNE BANQUE ?</h2>
        <h4 className="text-blue">
          Conseil et assistance - Gestion des procédures - Recouvrement de
          créances
        </h4>
        <p>
          Vous êtes une banque, un établissement de crédit ou une institution
          financière et recherchez un partenaire juridique fiable pour défendre
          vos intérêts ?
        </p>
        <container>
          <i class="fa-solid fa-comment"></i>
          <a href="tel:+33972121155" className="footer-btn-black">
            +33 (0) 9 72 12 11 55
          </a>
        </container>
        <container>
          <i class="fa-solid fa-phone-volume"></i>
          <a href="mailto:info@lexicredis.fr" className="footer-btn-black">
            info@lexicredis.fr
          </a>
        </container>
      </div>
      <form onSubmit={handleSubmit} className="contact-form">
        <input
          type="text"
          placeholder="Nom"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
        />
        <input
          type="email"
          placeholder="Email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <input
          placeholder="Message"
          name="message"
          value={formData.message}
          onChange={handleChange}
          required
        />
        <button type="submit" className="btn-fill">
          Envoyer
        </button>
      </form>
    </section>
  );
};

export default Contact;
